import './style.css';
import Events from 'f.core.event';
import antiTheft from 'f.component.video.auth';
import { recodeVideo as Pcvideo } from 'f.component.video.pc';
import VStat from 'f.component.video.vStat';

import CanUseMse from 'canUseMse';
import version from 'version';



/**
 * 整个播放器模块
 */
class wideo {
    /**
     * Creates an instance of wideo.
     * @param {object} obj
     * @param {object} obj.playermsg 当前视频信息
     * @param {object} obj.videoinfo 当前视频信息-地址
     * @param {object} obj.recommend 后推荐数据
     * @param {object} obj.sedata 视频列表数据
     */
    constructor({ playermsg, videoinfo, recommend, sedata, isAuth, isMse, showTestInfo }) {
        this.playermsg = playermsg;
        this.videoinfo = videoinfo;
        this.recommend = recommend;
        this.sedata = sedata;
        this.isAuth = isAuth || 'auth';
        this.isMse = isMse && true;
        this.showTestInfo = showTestInfo || false;
        const vStat = new VStat(videoinfo);
        window.gid = vStat.createUid();
        window.randomNum = vStat.createNum();
        this.init();
    }

    init() {
        let canUseObj = new CanUseMse();
        this.canUseMse = canUseObj.judgement(); // 判断浏览器能否支持mse
        this.first = true; // 是否为第一次播放
        this._errcode = false;
        this.initComponent();
        this.initEvent();
    }

    /**
     * 初始化组件
     */
    initComponent() {
        // 初始化正片      依赖 videoinfo

        this.initLoadingImg();
    }

    initPcVideo(_this) {
        let __gid = window.gid;
        _this.pcvideo = new Pcvideo({
            videoinfo: _this.videoinfo,
            playermsg: _this.playermsg,
            recommend: _this.recommend,
            sedata: _this.sedata,
            isAuth: _this.isAuth,
        });

        const mp4urlgid = `${_this.pcvideo.srcVideoUrl}?${antiTheft({ videoinfo, __gid, version })}`;
        _this.pcvideo.src(mp4urlgid);

        _this.pcvideo.hide();

        _this.initPcVideoEvent();
    }

    /**
     * 初始化loading图
     */
    initLoadingImg() {
        let img = `
            <div class="loading" style="width:100%;height:100%;position:absolute;top:0;left:0;">
            <div class="loadingbanner"></div>
            </div>
        `;
        $('#js_video_container').html(img);
    }

    /**
     * 初始化事件
     */
    initEvent() {
        let _this = this;

        _this.initPcVideo(_this);
        // pcvideo.src('http://ips.ifeng.com/video19.ifeng.com/video01/2007/10/27/2d07c660-7748-4266-a5a1-214763920bf2.flv');
        _this.pcvideo.show();
        _this.pcvideo.play();
        _this.trigger('start');


        /**
         * 开始播放
         */
        $('.videobox').on('click', '#js_videopause_container', e => {
            const vi = document.getElementById('player');

            if (vi.currentTime > 0) {
                _this.pcvideo.play();
                $('#js_videopause_container').hide();
            }
        });
    }

    initPcVideoEvent() {
        let _this = this;

        /**
         * 重播
         */
        _this.pcvideo.on('replay', () => {
            $('.videoPlayer .loading').show();
        });

        /**
         * 正片能播放时
         */
        _this.pcvideo.on('canplay', () => {
            if ($('.videoPlayer .loading')) {
                $('.videoPlayer .loading').hide();
            }

        });

        /**
         * 播放中
         */
        _this.pcvideo.on('timeupdate', currentTime => {
            // if (currentTime === 0) return;
        });

        /**
         * 播放出现错误时
         */
        _this.pcvideo.on('error', (code, currentTime) => {
            // console.log(_this.adTag);
            /**
             * 广告播完了 或者没有广告才可以显示错误
             */
            if (_this.adTag) {
                _this.pcvideo.recommend.initShow();
                _this.pcvideo.error.show();
                // core.hide();
                _this.pcvideo.control.hide();
            }

            /**
             * 没发过_errcode才可以发送错误
             */
            if (_this._errcode === false) {
                vStat.sendVplayer(`44000${code}`);
                if (!currentTime) {
                    vStat.sendVplayer('301040');
                }
                _this._errcode = true;
                _this.errShow = true;
            }
        });

        /**
         * 开始播放
         */
        _this.pcvideo.on('play', () => {
            if (_this.advideo && _this.advideo.AdPause) {
                _this.advideo.AdPause.hide();
            }
        });

        /**
         * 播放暂停
         */
        _this.pcvideo.on('pause', () => {
            _this.advideo && _this.advideo.pauseAdShow();
        });
    }
}

Events.mixTo(wideo);
window.wideo = wideo;



// WEBPACK FOOTER //
// ./pages/simple/app.js